<div class="top-nav-bar" ui-row uiAlign="middle">
  <div class="top-nav-bar__toggle-nav border-right" *ngIf="!isNavExpanded" ui-col>
    <toggle-nav [isNextIcon]="true" uiId="top-subnav-toggle" action="expand"></toggle-nav>
  </div>
  <div class="top-nav-bar__header-container" [class.top-nav-bar__title-container--pl-8]="!isNavExpanded" ui-col ui-row uiAlign="middle">
    <div class="top-nav-bar__title-container">
      <ng-container *ngIf="navSubTitle">
        <p class="top-nav-bar__subtitle" ui-col>{{ navSubTitle }}</p>
        <span class="top-nav-bar__title-divider">/</span>
      </ng-container>
      <p class="top-nav-bar__title" ui-col>{{ navTitle }}</p>
    </div>
    <ng-container *ngIf="showFavIcon">
      <i ui-icon uiType="gh-favorite" ui-col></i>
    </ng-container>
    <div *ngIf="showDropdown" ui-col>
      <ng-content select="[top-nav-bar-dropdown]"></ng-content>
    </div>
    <div class="top-nav-bar__tabs-container" *ngIf="showTabs">
      <ng-content select="[top-nav-bar-tab]"></ng-content>
    </div>
  </div>
  <div class="top-nav-bar__right-content" ui-col ui-row uiJustify="end">
    <div class="top-nav-bar__buttons-container" *ngIf="showButtons" ui-col>
      <ng-content select="[top-nav-bar-button]"></ng-content>
    </div>
    <div ui-col>
      <global-search ui-col></global-search>
    </div>
  </div>
</div>
<ui-divider class="sp-mb-0 sp-mt-0"></ui-divider>
